require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-159-use-zapier-to-sync-a-jira-project.json") })
        }
      }, "path---article-159-use-zapier-to-sync-a-jira-project");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-159-use-zapier-to-sync-a-jira-project!./.cache/json/article-159-use-zapier-to-sync-a-jira-project.json
// module id = 506
// module chunks = 231608221292675